import events from '../events/events';

const Notes = {};

/**
 * Notes plugin
 *
 * @param Vue
 * @param options
 */
Notes.install = function(Vue, options)
{
    let methods =
    {
        open(event, payload)
        {
            events.$emit('toolbox.open', 'notes', event, payload);
        },

        close()
        {
            events.$emit('toolbox.close');
        },
    };

    // register global methods
    Vue.notes = methods;

    // register instance methods
    Vue.prototype.$notes = methods;
};

export default Notes;



// WEBPACK FOOTER //
// ./src/js/plugins/notes.js